/**
 * Utility function to format supplier display consistently across the application
 * Format: "supplierId: supplierName (supplierCompany)"
 * 
 * @param {Object} supplier - The supplier object
 * @returns {string} - Formatted supplier display string
 */
export const formatSupplierDisplay = (supplier) => {
    if (!supplier) return '';

    const id = supplier.id || '';
    const name = supplier.name || supplier.first_name || '';
    const lastName = supplier.last_name || '';
    const company = supplier.company || '';

    // Build the full name
    const fullName = lastName ? `${name} ${lastName}`.trim() : name;

    // Format based on available data
    if (id && fullName && company) {
        return `${id}: ${fullName} (${company})`;
    } else if (id && fullName) {
        return `${id}: ${fullName}`;
    } else if (fullName && company) {
        return `${fullName} (${company})`;
    } else if (id && company) {
        return `${id}: (${company})`;
    } else if (fullName) {
        return fullName;
    } else if (id) {
        return id;
    } else if (company) {
        return `(${company})`;
    } else {
        return 'Unknown Supplier';
    }
};

/**
 * Utility function to format supplier display for Autocomplete options
 * Used in dropdowns and autocomplete components
 * 
 * @param {Object} supplier - The supplier object
 * @returns {string} - Formatted supplier display string for autocomplete
 */
export const formatSupplierForAutocomplete = (supplier) => {
    if (!supplier) return '';

    const id = supplier.id || '';
    const name = supplier.name || supplier.first_name || '';
    const lastName = supplier.last_name || '';
    const company = supplier.company || '';

    // Build the full name
    const fullName = lastName ? `${name} ${lastName}`.trim() : name;

    // Format for autocomplete (shorter format)
    if (id && fullName && company) {
        return `${id} ${fullName} : ${company}`;
    } else if (id && fullName) {
        return `${id} ${fullName}`;
    } else if (fullName && company) {
        return `${fullName} : ${company}`;
    } else if (id && company) {
        return `${id} : ${company}`;
    } else if (fullName) {
        return fullName;
    } else if (id) {
        return id;
    } else if (company) {
        return company;
    } else {
        return 'Unknown Supplier';
    }
};
